var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30.816 -48.51)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.08763 0 0 .087871 -16.142 24.976)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4972 0 0 1.4931 365.82 -62.03)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 113.58,
    y: 220.92,
    width: 243.9,
    height: 243.9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m633.97 365.18 170.3 170.3",
    fill: "none",
    stroke: "#e7e7eb",
    strokeWidth: "31px"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 1437.2 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m633.97 365.18 170.3 170.3",
    fill: "none",
    stroke: "#e7e7eb",
    strokeWidth: "31px"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.c83272455e6d3d6e7c2698308198f295.svg";
export { ForwardRef as ReactComponent };